import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import '../Styles/CarouselStyles.css'; 

const CarouselComponent = ({ images }) => {
  return (
    <>
      {images && images.length > 0 ? (
        <Carousel>
          {images.map((image, index) => (
            <Carousel.Item key={index}>
              <img
                src={image.urlImage}
                alt={`Imagen ${index}`}
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "contain",
                }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <div className="no-images">
          <p>   </p>
        </div>
      )}
    </>
  );
};

export default CarouselComponent;
